import React from 'react';
import BotonGhostEspeciales from '../BotonGhostEspeciales/index';

import './css/styles.css';

class PanelLaUnidadEquipoDirector extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            nombre: '',
            funcion: '',
            imagen: '',
        };
    }

    componentWillMount(){
        fetch('/api/uip/equipo/datos/director', {
            method: 'GET',
            headers: {
                'Content-type': 'application-json',
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    nombre: response[0].nombre,
                    funcion: response[0].funcion,
                    imagen: response[0].imagen,
                })
            })
    }

    render() {
        return (
            <section className="background_panel_especiales">
                <div className="container">
                    <div className="row">
                        <BotonGhostEspeciales text="Nuestro Equipo" />
                    </div>
                    <div className="row">
                        <div className="col s12 m12 l6">
                            <div className="row">
                                <div className="col s12 m1"></div>
                                <div className="col s12 m10">
                                    <div class="card z-depth-0">
                                        <div class="card-image">
                                            <img src={this.state.imagen} />
                                        </div>
                                    </div>
                                    <div className="col s12 m1"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col s12 m12 l6">
                            <div className="row">
                                <div className="col s12">
                                    <div class="card z-depth-0 transparent">
                                        <br/>
                                        <div class="card-content">
                                            <NombreDirector text={this.state.nombre}/>
                                            <p className="style_funcion">{this.state.funcion}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        );
    }
}

class NombreDirector extends React.Component{
    render(){
        return(
            <div className="row">
                <p className="equipo_nombre_director">{this.props.text}</p>
            </div>
        );
    }
}

export default PanelLaUnidadEquipoDirector;